import React from 'react'

const UsedTech = ({techStack}) => {
  return (
    <>
      
            
      <p className="mx-2">{ techStack}</p>
            

          
    </>
  )
}

export default UsedTech
